import { api } from '../index';
import { ITableParams } from '../baseApiTypes';

export const getNews = (params: ITableParams) => api.get('/news', { params });

export const createNews = (data: any) => api.post('/news/create', data);

export const getSingleNews = (id: any) => api.get(`/news/${id}`);

// @ts-ignore
export const updateNews = ({ id, data }) =>
  api.post(`/news/update/${id}`, data);

export const deleteNews = (id: any) => api.get(`/news/delete/${id}`);

export const NewsApi = {
  getNews,
  createNews,
  getSingleNews,
  updateNews,
  deleteNews,
};
